import { createAction, props } from '@ngrx/store';
import { DataSource } from '@sharedModule/models/data-source.model';
import { PermissionListInterface } from '../types/permission-list';
import { PermissionListFilter } from '../types/permission-list-filter';

export const fetchPermissionList = createAction(
  '[Permission List] Permission List Fetch',
  props<{ filter?: PermissionListFilter }>()
);

export const updatePermissionListFilter = createAction(
  '[Permission Filter] Permission List update filter',
  props<{ filter?: PermissionListFilter }>()
);

export const loadedPermissionList = createAction(
  '[Permission List] Permission List Loaded',
  props<{ dataSource: DataSource<PermissionListInterface[]> }>()
);

export const failedPermissionList = createAction(
  '[Permission List] Permission List Failed'
);

export const deletePermission = createAction(
  '[Permission List] Delete Permission',
  props<{ permission_section_id: string }>()
);

export const resetPermissionList = createAction(
  '[Permission List] Reset Permission List'
);
